const UserUtils = {
  can (role, action, section, id = null) {
    if (!role || !role.permissions) return false
    const rules = role.permissions

    // grant for admin
    if (rules.admin === true) return true

    // grant for section
    if (rules[section] && rules[section].length) {
      if (rules[section].indexOf(action) >= 0) return true
    }

    // grant for document
    if (rules[id] && rules[id].length) {
      if (rules[id].indexOf(action) >= 0) return true
    }

    return false
  }
}

export default UserUtils



// WEBPACK FOOTER //
// ./app/lib/UserUtils.js